// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3D7IU","calendarButtons":"ClockData_calendarButtons__19c4X"};